import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../../../boot";
import axios from "axios";

// get orders

export const getOrders = createAsyncThunk("client/order-list", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(
      `${baseUrl}vancouverapis/admin/orders/api/v1/order-list`,
      data,
      {
        headers: {
          "auth-token": token,
        },
      }
    );
    console.log("response  data get orders",response)
    return response;
    
  } catch (error) {
    console.error("Error fetching orders - ", error);
    throw error;
  }
});
